const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/** Formats a byte size for display (e.g. file uploads). */
export function fData(value?: number | string | null): string {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const bytes = Number(value);
  if (Number.isNaN(bytes) || bytes < 0) {
    return String(value);
  }

  if (bytes === 0) {
    return '0 B';
  }

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    BYTE_UNITS.length - 1
  );
  const size = bytes / 1024 ** exponent;
  const decimals = exponent === 0 ? 0 : size < 10 ? 2 : 1;

  return `${size.toFixed(decimals)} ${BYTE_UNITS[exponent]}`;
}
